import { createContext } from 'react'

export interface EntityContextType {
  editing: boolean
  setEditing: React.Dispatch<React.SetStateAction<boolean>>
  authorizationSubject: string
}
const EntityContext = createContext<EntityContextType>(null as any)
export const { Provider } = EntityContext
export default EntityContext
